import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import React from 'react';
import ReactDOM from 'react-dom';
// TODO: To be changed in the future to a shared-generic PlacementHelper
const renderOnRightRail = (moduleConfig, moduleProps) => __awaiter(void 0, void 0, void 0, function* () {
    const reactRoot = document.createElement('div');
    const rightRail = document.querySelector('.sticky-modules-wrapper');
    if (!rightRail) {
        return null;
    }
    reactRoot.classList.add('discovery-module-rail-discussions-activity');
    reactRoot.style.width = '300px';
    rightRail === null || rightRail === void 0 ? void 0 : rightRail.insertAdjacentElement('beforebegin', reactRoot);
    const DiscoveryModuleRailDiscussionsActivity = yield import(
    /* webpackChunkName: "DiscoveryModuleRailDiscussionsActivityComponent" */ '../DiscoveryModuleRailDiscussionsActivity');
    ReactDOM.render(React.createElement(DiscoveryModuleRailDiscussionsActivity.default, buildModuleProps(moduleConfig, moduleProps)), reactRoot);
    return reactRoot;
});
export default renderOnRightRail;
